(function () {
    //get the formApp module
    var formApp = angular.module('formApp');

    //set the controller to the code here - the controller uses DataServices.
    formApp.controller('feedbackAdditionalInfoController',
        ['$scope', '$http', '$controller', '$filter', 'DataServices', 'UtilityServices', 'ValidationService', '$location', '$routeParams', '$rootScope', 'Constants',
            function ($scope, $http, $controller, $filter, DataServices, UtilityServices, ValidationService, $location, $routeParams, $rootScope, Constants) {

                // Inherit parent controller
                $controller('questionController', { $scope: $scope });
                $controller('followUpController', { $scope: $scope, feedbackType: Constants.FeedbackType.Complaint, incidentId: DataServices.responseInfo.incidentId });
                $controller('navigationController', { $scope: $scope });

                var filteredAddProgramList = [];
                var filteredAddProgramList1 = [];
                var filteredAddProgramList2 = [];
                var filteredAddProgramList3 = [];
                var filteredAddProgramList4 = [];

                $scope.isDH = function () {
                    if ($location.path().indexOf('DH') > -1) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }

                if (sessionStorage.getItem('popAdditionalInfoState') != 'shown') {
                    getOptions('dhhsprogram').then(function (result) {
                        DataServices.programRegisteredOriginalResponse = result;
                        filteredAddProgramList1 = DataServices.programRegisteredOriginalResponse;
                        sessionStorage.setItem('popAdditionalInfoState', 'shown')
                        populateFormFields();
                    });
                }
                else {
                    if (DataServices.programRegisteredOriginalResponse.length === 0) {
                        getOptions('dhhsprogram').then(function (result) {
                            filteredAddProgramList1 = result;
                            populateFormFields();
                        });
                    }
                    else {
                        filteredAddProgramList1 = DataServices.programRegisteredOriginalResponse;
                        populateFormFields();
                    }

                }


                function populateFormFields() {
                    if ($location.path().indexOf('DH') > -1) {
                        if (DataServices.responseInfo.lastUpdatedTime == null || DataServices.isDHComplaint) {
                            for (var j = 0; j < filteredAddProgramList1.length; j++) {
                                if (filteredAddProgramList1[j].text == 'Covid19' || filteredAddProgramList1[j].text == 'Health') {
                                    filteredAddProgramList.push(filteredAddProgramList1[j]);
                                }
                            }
                        }
                        else {
                            for (var a = 0; a < filteredAddProgramList1.length; a++) {
                                if (!(filteredAddProgramList1[a].text == 'Covid19' || filteredAddProgramList1[a].text == 'Community Health' || filteredAddProgramList1[a].text == 'Fairness')) {
                                    filteredAddProgramList.push(filteredAddProgramList1[a]);
                                }
                            }
                        }
                    }
                    else {
                        if (DataServices.responseInfo.lastUpdatedTime == null || DataServices.isDFFHComplaint) {
                            for (var l = 0; l < filteredAddProgramList1.length; l++) {
                                if (!(filteredAddProgramList1[l].text == 'Covid19' || filteredAddProgramList1[l].text == 'Health')) {
                                    filteredAddProgramList.push(filteredAddProgramList1[l]);
                                }
                            }
                        }
                        else {
                            for (var b = 0; b < filteredAddProgramList1.length; b++) {
                                if (!(filteredAddProgramList1[b].text == 'Covid19' || filteredAddProgramList1[b].text == 'Community Health' || filteredAddProgramList1[b].text == 'Fairness')) {
                                    filteredAddProgramList.push(filteredAddProgramList1[b]);
                                }
                            }
                        }

                        if ($scope.isDH() == false) {
                            if (DataServices.responseInfo.ComplaintsFormData != null && DataServices.responseInfo.ComplaintsFormData.rDAuthorisedOfficer == null) {
                                delete DataServices.responseInfo.ComplaintsFormData.rDAuthorisedOfficer;
                            }
                        }
                    }
                    DataServices.configData.optionSets["dhhsprogram"] = filteredAddProgramList;

                    if ($location.path().indexOf('feedbackAdditionalInfo/1/feedback') > -1) {
                        if (sessionStorage.getItem('popAdditionalInfoNavigationState') != 'shown') {

                            filteredAddProgramList4 = $scope.configData.navigationTabs[0].pages.slice();

                            DataServices.navigationTabsOriginalResponse = filteredAddProgramList4;
                            DataServices.navigationTabsResponse = $scope.configData;

                            sessionStorage.setItem('popAdditionalInfoNavigationState', 'shown');
                        }
                        if (window.location.href.indexOf('DH') > -1) {
                            if (DataServices.responseInfo.lastUpdatedTime == null) {
                                if (($scope.configData.navigationTabs[0].title == 'Feedback')) {
                                    filteredAddProgramList2 = $scope.configData.navigationTabs[0].pages.slice();

                                    for (var j = 0; j < filteredAddProgramList2.length; j++) {
                                        if (!(filteredAddProgramList2[j].title == 'Child Details')) {
                                            //filteredProgramList2.navigationTabs[i].pages.splice(j, 1);
                                            filteredAddProgramList3.push(filteredAddProgramList2[j]);
                                        }
                                    }

                                }
                            }
                            else {
                                if ((DataServices.responseInfo.lastUpdatedTime != null) && DataServices.isDHHSComplaint) {
                                    filteredAddProgramList3 = $scope.configData.navigationTabs[0].pages;
                                }
                                else {
                                    if (($scope.configData.navigationTabs[0].title == 'Feedback')) {
                                        filteredAddProgramList2 = $scope.configData.navigationTabs[0].pages.slice();

                                        for (var j = 0; j < filteredAddProgramList2.length; j++) {
                                            if (!(filteredAddProgramList2[j].title == 'Child Details')) {
                                                //filteredProgramList2.navigationTabs[i].pages.splice(j, 1);
                                                filteredAddProgramList3.push(filteredAddProgramList2[j]);
                                            }
                                        }

                                    }
                                }
                            }
                            $scope.configData.navigationTabs[0].pages = filteredAddProgramList3;
                            //DataServices.navigationTabsOriginalResponse = $scope.configData;
                            // $scope.configData = DataServices.navigationTabsResponse;
                        }
                        else {
                            $scope.configData.navigationTabs[0].pages = $scope.configData.navigationTabs[0].pages;
                        }

                    }
                }

                function getOptions(optionset) {
                    return ($scope.utility.getOptionSetFromConfiguration(optionset, Constants.ConfigTemplate.feedbackAdditionalInfo));
                }

                // only get the config data if we don't have it
                DataServices.getConfigurationUsingCache(Constants.ConfigTemplate.feedbackAdditionalInfo, $scope.versionNumber, null, DataServices.isAuthenticated())
                    .then(function () {
                        $scope.setupTriggersAndDynamicValues();
                        $scope.setSummaryErrorFocus();
                        $scope.isPageEditable = DataServices.isFollowUpEditable === true && $scope.page.isEditable === true;

                        document.title = $scope.utility.getPageTitle($scope.navTabNum, $scope.pageUrl);
                    });

                $scope.status = DataServices.responseInfo.status;
                $scope.incidentRef = DataServices.responseInfo.incidentRef;
                $scope.statusText = DataServices.responseInfo.statusText;
                $scope.template = Constants.ConfigTemplate.feedbackAdditionalInfo;
                $scope.ComplaintsFormData = DataServices.responseInfo.ComplaintsFormData;

                if ($scope.ComplaintsFormData["cDActingOnBehalfOfAnotherPerson"] === "yes") {
                    $scope.ComplaintsFormData["clientDetailsList"] = JSON.parse(DataServices.responseInfo.ComplaintsFormData.rDclientdetails);
                }

                if ($scope.isDH() == false) {
                    if ($scope.ComplaintsFormData.rDAuthorisedOfficer == null) {
                        delete $scope.ComplaintsFormData.rDAuthorisedOfficer;
                    }
                }

                $scope.saveAdditionalInfo = function () {
                    //// no validation 
                    $scope.currentLoadSubmitMessage = "Saving Feedback Assessment";
                    $scope.callSaveFollowUp($scope.feedbackType).then(function () {
                        // go back to co-ordination page
                        $scope.returnToCoordinationPage();
                    });
                }

                function validateForm() {
                    var isValid = true;
                    var previousPageId = $scope.pageId;
                    //Clearing the validation errors
                    $scope.validationErrors.length = 0;

                    $scope.configData.navigationTabs.forEach(function (tab) {
                        tab.pages.forEach(function (page) {
                            var pageId = tab.number + '-' + page.number;
                            $scope.pageId = pageId;
                            if ($scope.responses[pageId] === undefined || $scope.responses[pageId] === null) {
                                isValid = false
                            } else {
                                var isPageValid = $scope.validatePage(tab.number, page.url, null, null, null, 'inline', true);
                                if (isPageValid === false) {
                                    isValid = false;
                                }
                            }
                        });
                    });

                    $scope.pageId = previousPageId;
                    return isValid;
                }

                $scope.submitAdditionalInfo = function () {
                    //// implement submit logic
                    if (validateForm()) {
                        $scope.currentLoadSubmitMessage = "Submitting Feedback Assessment";
                        $scope.callSubmitFollowUp($scope.feedbackType).then(function () {
                            $scope.returnToCoordinationPage();
                        });
                    }
                    else {
                        if ($scope.validationErrors !== null && $scope.validationErrors !== undefined) {
                            if ($scope.validationErrors.length > 0) {
                                var error = $scope.validationErrors[0];
                                var tabNum = error.pageNo.split("-")[0];
                                var pageNum = error.pageNo.split("-")[1];
                                var page = $scope.configData.navigationTabs[tabNum - 1].pages[pageNum - 1];
                                ExpandErroredSections("1-3", "childdetails");

                                $scope.utility
                                    .openPopup('reviewComplaintErrors').result
                                    .then(function (data) {
                                        $scope.goToPage(tabNum, page.url);
                                    });
                            }
                            else {
                                $scope.utility
                                    .openPopup('reviewComplaintErrors').result
                                    .then(function (data) {
                                        $scope.goToPage(1, 'additionalinfo');
                                    });
                            }
                        }
                    }
                }

                function ExpandErroredSections(pageId, sectionName) {
                    //Expanding the error sections
                    var errorSectionIndexList = [];
                    $scope.validationErrors.forEach(function (error) {
                        if (error.pageNo === pageId && error.pageIndex === 0 && error.sectionCode === sectionName) {
                            if (errorSectionIndexList.indexOf(error.sectionIndex) === -1) {
                                errorSectionIndexList.push(error.sectionIndex);
                            }
                        }
                    });

                    if (errorSectionIndexList.length > 0) {
                        errorSectionIndexList.forEach(function (sectionIndex) {
                            $scope.responses[pageId][0][sectionName][sectionIndex].$state = "Editing";
                        });
                    }
                }

                $scope.cancel = function () {
                    $scope.callCancelFollowUp();
                }


                $scope.getValueDateFromResponse = function (qCode) {
                    var value = $scope.ComplaintsFormData[qCode];
                    if (value == undefined) {
                        return "";
                    }

                    return UtilityServices.formateDate(value);
                }

                $scope.clientDetailsLoaded = false;
                $scope.getValueFromResponse = function (qCode) {
                    var value = $scope.ComplaintsFormData[qCode];

                    if (value == undefined && qCode == 'rDAuthorisedOfficer') {
                        return "N/A";
                    }

                    if (value == undefined) {
                        return "";
                    }
                    if (qCode === "cDActingOnBehalfOfAnotherPerson" && value === "yes" && $scope.clientDetailsLoaded === false) {
                        loadClientDetails();
                    }
                    //Setting the date received(derived value) to the model so that we  can use it for pdf generation
                    else if (qCode === "aDDateReceived") {
                        if ($scope.responses["1-2"] !== null && $scope.responses["1-2"].length > 0
                            && $scope.responses["1-2"][0]["additionalinfo"] !== null && $scope.responses["1-2"][0]["additionalinfo"].length > 0) {
                            $scope.responses["1-2"][0]["additionalinfo"][0]["aDDateReceived"] = value;
                        }
                    }
                    else if (qCode === "cDActingOnBehalfOfAnotherPerson" || qCode === "") {
                        $scope.responses["1-1"][0]["onbehalfof"][0]["cDActingOnBehalfOfAnotherPerson"] = value;
                    }
                    else if (qCode === "rDRequireInterpreter" || qCode === "rDInterpreterLanguage") {
                        $scope.responses["1-1"][0]["yourdetails"][0][qCode] = value;
                    }
                    else if (qCode === "rDTypeOfFeedback") {
                        //Capitalize first letter of the word.
                        value = value.charAt(0).toUpperCase() + value.slice(1);
                    }

                    //setting the feedbacksummary
                    $scope.responses["1-1"][0]["complaintdetails"][0]["cOFeedbackSummary"] = $scope.ComplaintsFormData["cOFeedbackSummary"];

                    return value;
                }

                $scope.getClientDetailsFromResponse = function (qCode, sIndex) {
                    if ($scope.ComplaintsFormData["clientDetailsList"] !== undefined) {
                        return $scope.ComplaintsFormData["clientDetailsList"][sIndex][qCode];
                    }
                }

                function loadClientDetails() {
                    var clientdetails = JSON.parse(DataServices.responseInfo.ComplaintsFormData.rDclientdetails);
                    $scope.responses["1-1"][0]["clientdetails"] = clientdetails;
                    $scope.clientDetailsLoaded = true;

                }

                $scope.getValueFromResponseLookUp = function (qCode) {
                    var value = $scope.ComplaintsFormData[qCode];
                    if (value == undefined) {
                        return "";
                    }

                    return value;
                }

            }]);
}());